import React from 'react';
import {
  FDContentContainer, FDImage, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import EmbeddedSalesforceChatForEQF
  from 'Views/Onboarding/Components/HeaderBar/PlannerChat/EmbeddedSalesforceChatForEQF';
import { ScheduleMeetingButton } from './ScheduleMeetingButton';

const StandardEQFFQResponseCompleted = () => {
  const { resource } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  useBoneBackgroundColor();

  return (
    <QuizWrapperLayout>
      <FDContentContainer maxWidth={'xs'}>
        <LottieLoadingLayout>
          <FDStack direction={'column'} spacing={3}>
            {resource.withRelationship(fr.relationships.image.name, (rel) => {
              return (
                <FDImage
                  width={'100%'}
                  alt={rel.meta('altText')}
                  src={rel.link('related').url()}
                  aspectRatio={rel.meta('aspectRatio')}
                  {...dataAttrs('eqf-standard-quiz-completed-image')}
                />
              );
            }, () => null)}
            {resource.withRelationship(fr.relationships.lottie.name,
              (rel) => (
                <LottieRel relationship={rel} width={'250px'} height={'250px'} />
              ),
              () => null)}
            <MetaControlField attr={'completedTitle'} {...dataAttrs('fq-completed-title')} />
            <MetaControlField attr={'descriptions'} />
            <ScheduleMeetingButton resource={resource} isModal={false} />
            {resource.withRelationship(fr.relationships.learnSite.name, (rel) => (
              <FDPrimaryActionButton
                icon={rel.meta('icon')}
                label={rel.meta('prompt')}
                href={rel.link('related').url()}
                onClick={() => {
                  logStandardizedEvent(categories.facetQuiz, eventTypes.completed, eventSubTypes.clickedCTA, {
                    eventProperties: {
                      ...buildCommonFQEventProperties(resource),
                      action: 'learn more',
                    },
                  });
                }}
                {...dataAttrs('education-resources')}
              />
            ), () => null)}
            {resource.withRelationship(fr.relationships.foundationsMarketingSite.name, (rel) => (
              <FDPrimaryActionButton
                icon={rel.meta('icon')}
                label={rel.meta('prompt')}
                href={rel.link('related').url()}
                onClick={() => {
                  logStandardizedEvent(categories.facetQuiz, eventTypes.completed, eventSubTypes.clickedCTA, {
                    eventProperties: {
                      ...buildCommonFQEventProperties(resource),
                      action: 'foundations marketing site',
                    },
                  });
                }}
                {...dataAttrs('foundations-site')}
              />
            ), () => null)}
            {resource.withRelationship(fr.relationships.eqfChat.name, () => (
              <EmbeddedSalesforceChatForEQF resource={resource} />
            ), () => null)}
          </FDStack>
        </LottieLoadingLayout>
      </FDContentContainer>
    </QuizWrapperLayout>
  );
};
export { StandardEQFFQResponseCompleted };
